import { useCallback, useEffect, useMemo, useState } from "react";
import { trackBuyerChecklistEvent } from "../constants/buyerChecklistConstants";
import {
  calculateChecklistProgress,
  isChecklistComplete,
  loadChecklistState,
  saveChecklistState,
  clearChecklistState,
} from "../utils/buyerChecklistStorage";

export function useBuyerChecklistProgress(listingId = null, itemIds = []) {
  const [checked, setChecked] = useState({});
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    const state = loadChecklistState(listingId);
    setChecked(state.checked || {});
    setHydrated(true);
  }, [listingId]);

  const progress = useMemo(
    () => calculateChecklistProgress(itemIds, checked),
    [itemIds, checked]
  );

  const toggleItem = useCallback(
    (itemId, nextChecked) => {
      setChecked((prev) => {
        const next = { ...prev, [itemId]: nextChecked };
        saveChecklistState(listingId, next);
        trackBuyerChecklistEvent(nextChecked ? "buyer_checklist_item_checked" : "buyer_checklist_item_unchecked", {
          itemId,
          listingId,
        });
        trackBuyerChecklistEvent("buyer_checklist_progress_updated", {
          listingId,
          ...calculateChecklistProgress(itemIds, next),
        });
        if (isChecklistComplete(itemIds, next)) {
          trackBuyerChecklistEvent("buyer_checklist_complete", { listingId });
        }
        return next;
      });
    },
    [listingId, itemIds]
  );

  const resetProgress = useCallback(() => {
    clearChecklistState(listingId);
    setChecked({});
    trackBuyerChecklistEvent("buyer_checklist_progress_updated", { listingId, cleared: true });
  }, [listingId]);

  return {
    checked,
    hydrated,
    progress,
    toggleItem,
    resetProgress,
    isComplete: isChecklistComplete(itemIds, checked),
  };
}
